export default __webpack_public_path__ + "static/media/P2_image1.9a36e356.png";